import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';

import toggleSideNav from 'modules/_shared/redux/sideNavActions';

const isUILimitedVersion = !!JSON.parse(
  process.env.REACT_APP_UI_LIMITED_VERSION || 'false'
);

const billingUrl = process.env.REACT_APP_STRIPE_BILLING_URL || null;

const SecondaryMenu = () => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  return (
    <ul className="nk-menu nk-menu-sm" id="secondary-menu__fixed">
      <li className="nk-menu-heading">
        <span>{t('Account')}</span>
      </li>

      {/* MY DATA */}
      <li className="nk-menu-item">
        <Link
          to="/perfil-usuario/datos"
          className="nk-menu-link"
          onClick={() => dispatch(toggleSideNav())}
        >
          <span className="nk-menu-icon">
            <em className="icon ni ni-user-round" />
          </span>
          <span className="nk-menu-text">{t('MyData')}</span>
        </Link>
      </li>

      {/* SUBSCRIPTION */}
      <li className="nk-menu-item">
        <a
          href={billingUrl || '/'}
          target="_blank"
          rel="noreferrer"
          className={`nk-menu-link ${billingUrl ? '' : 'is-disable'}`}
          onClick={() => dispatch(toggleSideNav())}
        >
          <span className="nk-menu-icon">
            <em className="icon ni ni-report-profit" />
          </span>
          <span className="nk-menu-text">{t('Subscription')}</span>
        </a>
      </li>

      {/* CONTACT */}
      {!isUILimitedVersion && (
        <li className="nk-menu-item">
          <Link
            to="/contacto"
            className="nk-menu-link"
            onClick={() => dispatch(toggleSideNav())}
          >
            <span className="nk-menu-icon">
              <em className="icon ni ni-external" />
            </span>
            <span className="nk-menu-text">{t('Contact')}</span>
          </Link>
        </li>
      )}

      {/* HELP & SUPPORT */}
      <li className="nk-menu-item">
        <a
          href="https://ayuda.sttok.com/"
          target="_blank"
          rel="noreferrer"
          className="nk-menu-link"
          onClick={() => dispatch(toggleSideNav())}
        >
          <span className="nk-menu-icon">
            <em className="icon ni ni-info" />
          </span>
          <span className="nk-menu-text">{t('Help')}</span>
        </a>
      </li>
    </ul>
  );
};

export default SecondaryMenu;
